import React from 'react'

function ReturnDashboardIcon(props) {
  return (
    <svg width="21" height="21" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.5001 11.8751C21.5001 13.8642 20.7099 15.7719 19.3034 17.1784C17.8969 18.5849 15.9892 19.3751 14.0001 19.3751H1.25008V17.8751H14.0001C15.5914 17.8751 17.1175 17.243 18.2427 16.1177C19.3679 14.9925 20.0001 13.4664 20.0001 11.8751C20.0001 10.2838 19.3679 8.75768 18.2427 7.63247C17.1175 6.50725 15.5914 5.87511 14.0001 5.87511H3.32008L6.23008 8.29761L5.27008 9.45261L0.0800781 5.12511L5.27008 0.797607L6.23008 1.95261L3.32008 4.37511H14.0001C15.9892 4.37511 17.8969 5.16528 19.3034 6.57181C20.7099 7.97833 21.5001 9.88598 21.5001 11.8751Z"
        fill="currentcolor"
        fill-opacity="0.8"
      />
    </svg>
  )
}

export default ReturnDashboardIcon
